<template>
  <div class="flex flex-wrap px-0 relative">
    <div class="absolute top-0 -mt-1">
      <RolintLink
        :giata-id="hotel.giataId"
        text="EDIT HOTEL IMAGES"
      />
      <RolintLink
        :giata-id="hotel.giataId"
        edit="description"
        text="EDIT HOTEL DESCRIPTION"
      />
    </div>

    <div
      class="w-12/12 flex capitalize mb-4"
    >
      <h4 class="mr-6 mb-0">
        {{ hotel.propertyName }}
      </h4>
      <LazyStars
        v-if="hotel.rating || hotel.category"
        :score="hotel.rating || hotel.category"
        size="xl"
        class="-mt-1"
      />
    </div>

    <div
      v-if="hotel.trips?.length"
      class="w-12/12 flex flex-col mb-4 md:mb-4 pb-0 md:pb-3 pt-0 hotel-page-in-travels"
    >
      <div>
        <nuxt-link
          v-for="trip in hotel.trips"
          :key="trip.id"
          class="bg-dirty-blue float-left text-black mr-2 mb-2 px-4 text-nowrap py-2 hotel-page-related-travel-link rounded-[1.25rem] font-secondary"
          :to="`/${trip.inetsida}`"
        >
          {{ trip.rubrik }}
        </nuxt-link>
      </div>
    </div>
    <div class="w-12/12 mb-4 md:mb-5">
      <strong class="block mb-2">
        {{ hotel.city ? hotel.city + ', ' + hotel.country : '' }}
      </strong>
      <HotelPreview
        :hotel="hotel"
        :initial-slide="1"
      />
    </div>
    <div
      v-if="hotel.description"
      class="w-12/12 mb-2 md:mb-3 font-secondary"
    >
      <div
        v-if="hotel.allowHtmlDescription"
        class="whitespace-pre-line"
        v-html="toUnixNewlines(hotel.description)"
      />
      <p
        v-else
        class="whitespace-pre-line"
        :data-translation="hotel.description_translationkey"
      >
        {{ toUnixNewlines(hotel.description) }}
      </p>
      <p
        v-if="hotel.descriptions?.amenities"
        class="whitespace-pre-line"
      >
        {{ toUnixNewlines(hotel.descriptions?.amenities) }}
      </p>
    </div>
    <div class="w-12/12 mb-8">
      <a
        v-if="hotel.link"
        :href="washedHotelLink"
        target="_blank"
        data-i18n="seeHotelWebsite"
        class="text-blue-800 font-semibold font-secondary underline hover:underline"
      >{{ $t('seeHotelWebsite') }}
      </a>
    </div>
    <div
      v-if="hotel.lat && hotel.lng"
      class="w-12/12 mb-8"
    >
      <LazyHotelDestinationMap
        :gmap-url="hotel.gmapUrl"
        :lat="hotel.lat"
        :lng="hotel.lng"
        :location="hotelLocation"
      />
    </div>
    <div
      v-if="hotel?.tripadvisor_data"
      class="w-12/12"
    >
      <LazyTripAdvisorInfo
        :data="hotel?.tripadvisor_data"
        pretty
      />
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({

  name: 'Hotel',

  props: {
    hotel: {
      type: Object,
      required: true,
    },

    isHotelPage: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hotelLocation () {
      return {
        destination: this.hotel.zone_name || this.hotel.address?.city,
        postcode: this.hotel.address?.postal_code ?? this.hotel.meta?.PostcodeZip,
        locality: this.hotel.address?.city || this.hotel.zone_name,
        country: this.hotel.country,
      }
    },

    washedHotelLink () {
      if (!this.hotel?.link) {
        return '#'
      }
      const { link } = this.hotel
      return link.startsWith('http')
        ? link
        : `//${link}`
    },
  },

  methods: {
    toUnixNewlines,
  },
})
</script>
